// The current API User DTO identifies the client, not the user/session ID.
// Keep the existing id-based UI sentinel contract while accepting that DTO.
export function normalizeUserSession(data) {
  if (!data || typeof data !== "object" || Array.isArray(data))
    return { id: -1 };
  if (typeof data.id === "number" && Number.isFinite(data.id)) return data;
  if (
    typeof data.clientId === "number" &&
    Number.isInteger(data.clientId) &&
    data.clientId > 0
  ) {
    return { ...data, id: data.clientId };
  }
  return { id: -1 };
}
